import { render, staticRenderFns } from "./Niif.vue?vue&type=template&id=247b5f82"
import script from "./Niif.vue?vue&type=script&lang=js"
export * from "./Niif.vue?vue&type=script&lang=js"
import style0 from "./Niif.vue?vue&type=style&index=0&id=247b5f82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports